import { BlockingModal } from 'components/BlockingModal/BlockingModal';
import React from 'react';
import styled from 'styled-components';

const Content = styled.div`
  padding: 24px;
  color: #414141;

  font-family: Lato;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
`;

interface DelayNextGameModalProps {
  open: boolean;
  dismissCallback: () => void;
  delayNextGameHandler: () => void;
}

export const DelayNextGameModal: React.FC<DelayNextGameModalProps> = (props) => {
  const { open, dismissCallback, delayNextGameHandler } = props;

  return (
    <BlockingModal
      open={open}
      onClose={dismissCallback}
      title='Delay next game?'
      confirmBtn={{
        intent: 'primary',
        label: 'Delay next game',
        onClick: delayNextGameHandler,
        width: '141px',
      }}
      cancelBtn={{
        intent: 'tertiary',
        label: 'Cancel',
        onClick: dismissCallback,
        width: '141px',
        // @ts-ignore
        ['data-test']: 'cancel-button',
        style: {
          backgroundColor: '#F5F5F5',
          color: '#414141',
        },
      }}
      maxWidth='xs'
      fullWidth
    >
      <Content>
        You'll stay in this session until you choose to end it. The next game won't start automatically, you can set it up from the schedule
        when you're ready.
      </Content>
    </BlockingModal>
  );
};
